/**
 * Allow user to toggle password and secret answer hiding.
 * Default is hidden.
 */
export default function addFieldShowHide() {
  const form = document.querySelector('#register');
  const passwordToggle = form.querySelector('.js-password-toggle');
  const secretToggle = form.querySelector('.js-secret-answer-toggle');

  if (passwordToggle) {
    passwordToggle.addEventListener('imagetogglechange', (event) => {
      const newType = (event.detail.index === 0) ? 'password' : 'text';
      form.querySelector('#user_password').type = newType;
      form.querySelector('#user_password_confirmation').type = newType;
    });
  }
  if (secretToggle) {
    secretToggle.addEventListener('imagetogglechange', (event) => {
      const newType = (event.detail.index === 0) ? 'password' : 'text';
      form.querySelector('#user_secret_answer').type = newType;
    });
  }
}
